import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TogglePanelComponent } from '@layout/help-menu/components/toggle-panel/toggle-panel.component';
import { ThemeOptionsListComponent } from '@layout/help-menu/components/theme-options-list/theme-options-list.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipDirective } from '@kaseya-design-components';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { Permission } from '@core/permissions/models/permission.enum';

@Component({
  selector: 'itc-theme-toggle-panel',
  templateUrl: 'theme-toggle-panel.component.html',
  styleUrl: 'theme-toggle-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TogglePanelComponent, ThemeOptionsListComponent, TranslatePipe, TooltipDirective],
})
export class ThemeTogglePanelComponent {
  private readonly permissionsFacade = inject(PermissionsFacade);

  readonly canModifyTheme = this.permissionsFacade.hasPermission(Permission.ThemeSettingsModify);
}
